import { APP_DEFINITION_ID } from './appAndWidgetIds';

// Signup form configuration
export const SIGNUP_FORM_ID = '78384e16-7b4d-4fab-7227-f687b3545659';
export const SIGNUP_FORM_NAMESPACE = 'wix.identity.sm.v1.form';
export const APP_DASHBOARD_URL = `/app/${APP_DEFINITION_ID}/`;

// Conductor FT (bare camelCase, read with experiments.get(...) === CONDUCTOR_FT.ENABLED).
// Gates the self-heal that re-creates the backing signup form when it is missing,
// on every editorReady rather than only on firstInstall. A missing form makes the
// widget throw "One or more forms are missing in the server response" and never render.
export const ENSURE_SIGNUP_FORM_FT = 'shouldEnsureSignupFormExists';

// Lightbox viewer-context mode set by thunderbolt when the signup form is opened as the
// complete-profile popup. Must match COMPLETE_PROFILE_POPUP_MODE in thunderbolt feature-site-members.
export const COMPLETE_PROFILE_MODE = 'completeProfile';
